import styled, { css } from 'styled-components';
import { SvgHelperWrapper } from '../../components';

export const ContentContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${theme.sz.s8};

    padding-top: ${theme.sz.s32};
    padding-bottom: ${theme.sz.s32};
    padding-left: ${theme.sz.s6};
    padding-right: ${theme.sz.s6};

    @media (min-width: ${theme.sz.md}) {
      padding-top: ${theme.sz.s54};
      padding-bottom: ${theme.sz.s54};
      gap: ${theme.sz.s12};
    }
  `,
);

export const ErrorImage = styled(SvgHelperWrapper)(
  ({ theme }) => css`
    width: ${theme.sz.s24};
    height: ${theme.sz.s24};

    @media (min-width: ${theme.sz.md}) {
      width: ${theme.sz.s32};
      height: ${theme.sz.s32};
    }
  `,
);

export const Subtitle = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.m}
    color: ${theme.co.secondary20};
    text-align: center;

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.l}
    }
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.m}
    color: ${theme.co.neutral0};
    text-align: center;

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.heading.desktop.l}
    }
  `,
);
